// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_t9-0";